// 文件上传代理
export const API_UPLOAD = '/upload2api';
// 目前只用这三个
export const API_JAVA = '/jgwApi';
export const API_SYS = '/jgwSys';
export const API_FDD = '/jgwFdd';
// 接口定义引用但是接口没有被引用
export const API_JAVA3 = '/java3api'



// WEBPACK FOOTER //
// ./src/utils/base.js